// extracted by mini-css-extract-plugin
export default {"tagBox":"TagBox_tagBox__7pRMx","tagList":"TagBox_tagList__aW0IN","tagDeleteBtn":"TagBox_tagDeleteBtn__FMuA0"};